module.exports = "<div ui-view> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/store-registration/store-registration.template.html
// module id = 141
// module chunks = 0